<script setup>
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { storeToRefs } from "pinia";
import { useWebsiteStore } from "@/stores/website";
import axios from "axios";
import { useUserStore } from "@/stores/user";
import { useRouter } from "vue-router";
import { EventBus } from '@/events/eventBus';
import TreeviewStructureFull from "@/components/PagePicker/TreeviewStructureFull.vue";
import Spinner from "@/components/Spinner.vue";

const userStore = useUserStore();
const {user} = storeToRefs(userStore);
const router = useRouter();
const websiteStore = useWebsiteStore();
const {lastUpdated, website} = storeToRefs(websiteStore);

const pageList = ref([])
const loaded = ref(false)

const tabEntry = ref('sitemap')

const morePages = ref({
  loaded: false,
  items: [],
});

async function loadMorePages() {
  return
  const modal = bootstrap.Modal.getInstance(document.getElementById('modal-add-more-pages'))
  if (!modal || !modal._isShown) {
    return
  }

  try {
    // Preserve currently selected page URLs before refetch
    const previouslySelected = new Set(
        morePages.value.items.filter(p => p.selected).map(p => p.url)
    )

    let r = await axios.get(`websites/${website.value.shortuuid}/next-pages/`)
    pageList.value = []
    for (let page of r.data.pages) {
      pageList.value.push(page)
    }

    morePages.value.items = r.data.pages
    // Restore selection for pages that were previously selected (by URL)
    for (let page of morePages.value.items) {
      page.selected = previouslySelected.has(page.url)
    }
    morePages.value.loaded = true
    selectAllInput.value = false
    console.log("Loaded more pages", morePages.value.loaded)
  } catch (e) {
    if (e.response.status >= 400) {
      if (e.response.data.code === 'subscription') {
        userStore.showNotification('plan')
      } else if (e.response.status === 401) {
        userStore.showNotification('login')
      }
    }
  }
  loaded.value = true;
}

const treeView = ref(null)
const busy = ref(false)

async function addPages() {
  let pages = selectedPages.value

  busy.value = true;
  const myModal = bootstrap.Modal.getInstance(document.getElementById('modal-add-more-pages'))

  try {
    let r = await axios.post(`websites/${website.value.shortuuid}/add-pages/`, {
      pages: pages
    })
    if (r.data.success) {
      myModal.hide()
      selectAllInput.value = false
      treeView.value.clearSelection();
      bulkPagesText.value = ''
      loadMorePages()
    }
  } catch (e) {
    if (e.response.status >= 400) {
      if (e.response.data.code === 'subscription') {
        // myModal.hide()
        userStore.showNotification('plan')
        // userStore.showUpgradeRequired()
      } else if (e.response.status === 401) {
        userStore.showNotification('login')
      }
    }
  } finally {
    busy.value = false;
  }

}

function navigateToSubscription() {
  const myModal = bootstrap.Modal.getInstance(document.getElementById('modal-add-more-pages'))
  if (myModal) {
    myModal.hide()
  }
  router.push({name: 'subscription'})
}

const selectAllInput = ref(false)


onMounted(() => {
      EventBus.on('refetchAll', loadMorePages);
    }
)
onUnmounted(() => {
  EventBus.off('refetchAll', loadMorePages);
});

let selectedSitemapPages = ref([])
let bulkPages = ref([])
let bulkPagesText = ref('')

function selectPages(pages) {
  selectedSitemapPages.value = pages;
}

watch(bulkPagesText, () => {
  bulkPages.value = []
  for (let line of bulkPagesText.value.split(/\r?\n/)) {
    if (line.startsWith(website.value.url)) {
      bulkPages.value.push(line)
    }
  }
})

const selectedPages = computed(() => {
  if (tabEntry.value === 'sitemap') {
    return selectedSitemapPages.value
  } else {
    return bulkPages.value;
  }
})


watch(websiteStore.sitemapPages, () => {
  console.log(websiteStore.sitemapPages)

  // Preserve currently selected page URLs before refetch
  // const previouslySelected = new Set(
  //     morePages.value.items.filter(p => p.selected).map(p => p.url)
  // )
  //
  // // Restore selection for pages that were previously selected (by URL)
  // for (let page of morePages.value.items) {
  //   page.selected = previouslySelected.has(page.url)
  // }

  pageList.value = websiteStore.sitemapPages.pages


  loaded.value = true

}, {})

// Explicitly expose methods or properties to the parent component
defineExpose({
  loadMorePages,
});
</script>

<template>
  <div
      class="modal"
      id="modal-add-more-pages"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-add-more-pages"
      aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">

      <div class="modal-content" v-if="website">

        <div class="block-rounded block-transparent block mb-0">
          <div class="block-header block-header-default pt-0 ps-2">
            <ul class="nav nav-tabs nav-tabs-alt">
              <li class="nav-item " @click.prevent="tabEntry='sitemap'"><a href="#"
                                                                           :class="{'nav-link': true, 'active': tabEntry === 'sitemap'}">Add
                Pages From Sitemap</a></li>
              <li class="nav-item" @click.prevent="tabEntry='bulk'"><a href="#"
                                                                       :class="{'nav-link': true, 'active': tabEntry === 'bulk'}">Bulk
                Add Pages </a></li>
            </ul>
            <div class="block-options space-x-1">
              <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close"><i
                  class="fa fa-fw fa-times"></i></button>
            </div>
          </div>
        </div>

        <div class="block-content m-0 p-0" v-show="tabEntry === 'sitemap'">
          <!--                <label class="p-3 text-muted pb-1">Select pages to add to your scan.</label>-->
          <div class="p-0 m-0">
            <div v-if="!loaded" class="p-4 text-muted">
              <spinner></spinner>
              Loading Pages..
            </div>
            <div v-else>
              <div class="alert alert-info m-2" role="alert" v-if="pageList.length === 0">
                This appears to be all the pages available. If you have more pages to add, please
                add them directly.
              </div>
              <treeview-structure-full ref="treeView" v-else @select-page="selectPages" @start-scan=""
                                       parent-path="seo-summary"
                                       :pageList="pageList"></treeview-structure-full>
            </div>
          </div>
        </div>
        <div class="block-content m-0 p-2" v-show="tabEntry === 'bulk'">
          <div class="mb-3 p-2">
            <label for="exampleFormControlTextarea1" class="form-label">Enter URL's (one per line)</label>
            <textarea v-model="bulkPagesText" class="form-control" id="exampleFormControlTextarea1" rows="8"
                      :placeholder="`${website.url}/`"></textarea>
          </div>
        </div>
        <div v-if="user" class="block-content block-content-full bg-body p-0">
          <div class="p-3 d-flex justify-content-between align-items-center">
            <div>
              <button
                  type="button"
                  class="btn btn-sm btn-alt-secondary me-1"
                  data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
            <div>
              <button
                  v-if="user.availableCredits > 0"
                  type="button"
                  @click="addPages"
                  :disabled="selectedPages.length === 0 || selectedPages.length > user.plan.pageLimit || busy"
                  class="btn btn-sm btn-primary"
              >
                <span v-if="busy" class="spinner-border spinner-border-sm"></span> Add {{ selectedPages.length }} Pages
              </button>
              <div v-else-if="user.availableCredits === 0"
                   class="text-warning d-flex align-items-center justify-content-between mb-0" role="alert">
                <div class="flex-grow-1 me-3">
                  <p class="mb-0 fs-sm">
                    <strong>Plan Limit Reached:</strong> Please upgrade your plan to add new pages.
                  </p>
                </div>
                <div class="flex-shrink-0">
                  <button @click="navigateToSubscription" class="btn btn-sm btn-primary">Upgrade</button>
                </div>
              </div>
              <div v-else-if="selectedPages.length > user.plan.pageLimit"
                   class="alert d-flex align-items-center justify-content-between m-2 mb-0" role="alert">
                <div class="flex-grow-1 me-3">
                  <p class="mb-0 fs-sm">
                    <strong>Plan Limit:</strong> You can add up to {{ user.plan.pageLimit }} pages at a time.
                  </p>
                </div>
                <div class="flex-shrink-0">
                  <button @click="navigateToSubscription" class="btn btn-sm btn-primary">Upgrade</button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<style>

</style>